import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

// TODO - ASi budou stejné pro všechny ve financích - Náklady, Penalizace, Příjmy, Bonusy bude se měnit jen form ID.
export const DetailFinancePenaltyDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.detail-finance-penalty");
    const id = DrawerId.DetailFinanceCost;

    return <Drawer drawerId={id} title={<DrawerTitle mainTitle={t("title")} />}></Drawer>;
};
